// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__UjhHV","legacyBtn":"MutateMid_legacyBtn__2_pJv"};